import { cssVar } from '@chakra-ui/react';
const useAppHeight = () => {
    return cssVar('app-height').reference;
};
export default useAppHeight;
